import { IGenre } from 'services/enums/types';
import {
  IArtistWithRoleForm,
  IArtistWithRoleMutation,
  ICopyrights,
  IExternalId,
  IInfinitePageParams,
  IInfinitePageResponse,
  ITitle,
  IVersion,
  IWaitingForFile,
  STATUS,
} from 'services/types';

export interface IVideoFilePath {
  videoLink?: string | null;
  originalVideoLink?: string | null;
}

export interface IVideoSubtitles {
  subtitles: string;
  language: number;
}

export interface IVideoArtistMutation extends IArtistWithRoleMutation {}

export interface IVideoArtistMutationForm extends IArtistWithRoleForm {}

export interface IVideoBase extends IVersion {
  pline: ICopyrights | null;
  cline: ICopyrights | null;
  language: number;
  originalVideoLink?: string | null;
  isCreatedWithAi: boolean;
  // source: TRACK_SOURCE;
  otherTitles: ITitle[];
  subtitles: IVideoSubtitles[];
  externalIds: IExternalId[];
  mainTitle: ITitle;
}

export interface IVideoMutation extends IVideoBase {
  status: STATUS;
  artists: IVideoArtistMutation[];
  isrc: string | null;
  genre: number | null;
  censorious: TRACK_CENSORIOUS | null;
  isInstrumental: boolean;
  id?: string;
}

export interface IVideoMutationForm
  extends Omit<IVideoMutation, 'artists' | 'genre' | 'censorious'>, IVideoFilePath {
  file?: File;
  artists: IVideoArtistMutationForm[];
  isrc: string;
  canUpdateISRC: boolean | null;
  genre: IGenre;
  censorious: TRACK_CENSORIOUS;
}

export interface IVideoId {
  videoId: string;
}

export interface ICreateVideo extends IVideoMutation, IWaitingForFile {}

export interface IUpdateVideo extends IVideoMutation, IWaitingForFile, IVideoId {}

export interface IVideoArtistResponse extends IVideoArtistMutationForm {
  rolePlacement: number;
}

export interface IVideoResponse extends IVideoBase, IVideoFilePath {
  id: string;
  videoStatus: STATUS;
  artists: IVideoArtistResponse[];
  canUpdateISRC: boolean;
  genre: IGenre | null;
  censorious: TRACK_CENSORIOUS | null;
  isrc: string | null;
  instrumental: boolean;
}

export interface IVideosResponse extends IVideoResponse {}

export interface IVideoPageResponse extends IInfinitePageResponse<IVideosResponse> {}

export interface IVideoSearch extends IInfinitePageParams {
  title?: string;
  isrc?: string;
  ean?: string;
  artistNickname?: string;
  artistName?: string;
  status?: STATUS;
  hasDuplicatedArtist?: boolean;
  hasContracts?: boolean;
}

export interface IVideoLight {
  id: string;
  mainTitle: string;
}

export interface IVideoFileUploadComplete extends IVersion {
  file: File;
  videoId: string;
}

export enum TRACK_CENSORIOUS {
  unknown = -1,
  explicit = 1,
  notExplicit = 2,
  clean = 3,
}

export enum TRACK_SOURCE {
  unknown = -1,
  local = 1,
  fromDistribution = 2,
}

export interface ICreateMusicProductDigitalFromVideo {
  videoId: string;
}

export type IMusicProductDigitalFromVideoResponse = string;
